import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LocaleState {
  activeLocale: string;
  activeCountry: string;
}

interface LocaleActions {
  setLocale: (locale: string) => void;
  setCountry: (country: string) => void;
}

/** Locale store — persisted to localStorage. */
export const useLocaleStore = create<LocaleState & LocaleActions>()(
  persist(
    (set) => ({
      activeLocale: 'en-US',
      activeCountry: 'US',

      setLocale: (locale) => set({ activeLocale: locale }),

      setCountry: (country) => set({ activeCountry: country }),
    }),
    {
      name: 'app-locale-store',
      version: 1,
    },
  ),
);
